const isContent = (item) => (item.element && ['p', 'ul', 'ol'].indexOf(item.element) > -1) || false;

// Return an array of suitable slots for ad placements
// A suitable slot is defined by the presence of two consecutive "content items"
// Each ad slot has references to its index in the body, and its index in terms of "content items"
function findAdSlots(body) {
  let contentCount = 0;

  const reducer = (adSlots, item, index) => {
    if (index >= body.length - 1) {
      return adSlots;
    }

    if (isContent(item)) {
      contentCount += 1;
    }

    if (isContent(item) && isContent(body[index + 1])) {
      return [...adSlots, { index, contentCount }];
    }

    return adSlots;
  };

  return body.reduce(reducer, []);
}

function insertAdvertisements(body) {
  const ad = { type: 'advertisement' };
  const adSlots = findAdSlots(body);
  const firstAdSlotPosition = 2;
  const subsequent = 4;
  let spacing = firstAdSlotPosition;
  let lastIndex = 0;
  // Entries in adPositions represent the number of paragraphs
  // (or other "content items") after which an ad should appear
  const adPositions = adSlots.filter((e) => {
    let addAd = false;
    if (spacing === firstAdSlotPosition && e.contentCount >= firstAdSlotPosition) {
      // First Placement.
      addAd = true;
    } else if (e.contentCount >= spacing && (lastIndex + subsequent) <= e.index) {
      // Subsequent placement is appropriately spaced from previous.
      addAd = true;
    }
    if (addAd) {
      lastIndex = e.index;
      spacing += subsequent;
    }
    return addAd;
  }).map((e) => e.index);

  // Splice ads into body in reverse to avoid need to increment indexes.
  adPositions.reverse().forEach((position) => {
    body.splice(position + 1, 0, ad);
  });

  return body;
}

function insertTaboolaElement(body) {
  const taboolaReadMoreBelow = { type: 'taboolaReadMoreBelow' };
  const indexOfFirstAd = body.findIndex((item) => item.type === 'advertisement');

  if (indexOfFirstAd > -1) {
    body.splice(indexOfFirstAd + 1, 0, taboolaReadMoreBelow);
  }

  return body;
}

export default function insertAdsIfNotNativeAd(
  nativeAd,
  adsEnabled,
  ecommerceEnabled,
  amp,
) {
  const isAmpAndEcommerce = ecommerceEnabled && amp;
  return (body) => (
    (nativeAd || !adsEnabled || isAmpAndEcommerce)
      ? body
      : insertTaboolaElement(insertAdvertisements(body))
  );
}
